import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <ToastContainer
      toastClassName={() =>
        "relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-black shadow-lg"
      }
      bodyClassName={() => "text-black text-base font-normal"}
      position="top-right"
      autoClose={4000}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    /> */}
    <ToastContainer
  toastClassName={() =>
    "relative flex py-4 px-4 rounded-lg overflow-hidden cursor-pointer bg-black shadow-xl border border-gray-200"
  }
  bodyClassName={() => "text-gray-900 text-base font-medium"}
  position="top-right"
  autoClose={4000}
  hideProgressBar={false}
  newestOnTop={false}
  closeButton={true}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="dark"
/>
    <App />
  </>
);
